/** Level 6 (claude/level-6-source): Lessons 1–21 in book order, plus the lettered lessons not in the book yet (extra.ts); check-ups in checkups.ts. */
import type { Lesson } from "../types";
import * as A from "./lesson01to10";
import * as B from "./lesson11to21";
import * as X from "./extra";

export const LEVEL6: Lesson[] = [
  A.L6_LESSON1, A.L6_LESSON2, A.L6_LESSON3, A.L6_LESSON4, A.L6_LESSON5, A.L6_LESSON6, X.L6_LESSON6A, A.L6_LESSON7, A.L6_LESSON8, X.L6_LESSON8A, A.L6_LESSON9, A.L6_LESSON10,
  B.L6_LESSON11, B.L6_LESSON12, B.L6_LESSON13, B.L6_LESSON14, X.L6_LESSON14A, B.L6_LESSON15, B.L6_LESSON16, B.L6_LESSON17, B.L6_LESSON18, B.L6_LESSON19, X.L6_LESSON19A, B.L6_LESSON20, B.L6_LESSON21,
];
export { L6_PRE, L6_POST } from "./checkups";
